import { instance } from "libs/api";

import { ApiRoutesTransfers } from "../../constants";
import { Transfer } from "../../transfers.types";

export const requestGetTransfer = async (
  transferId: string,
): Promise<Transfer> => {
  return await instance.get(`${ApiRoutesTransfers.Transfers}/${transferId}`);
};
